<template>
  <div>
    <el-upload
      :disabled="checked"
      class="upload-demo"
      action="#"
      multiple
      :limit="limit"
      :accept="accept"
      :file-list="fileList"
      :on-exceed="handleExceed"
      :on-change="handleChange"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
      :http-request="AdminUploadFileUp"
      :before-upload="beforeAvatarUpload"
      >
      <el-button size="small" type="primary">点击上传</el-button>
      <!-- <div slot="tip" class="el-upload__tip" style="line-height: 1;">只能上传jpg/png文件，且不超过500kb</div> -->
      <!-- <i class="el-icon-upload"></i> -->
      <!-- <div class="el-upload__text"><el-link :underline="false" type="">请将文件拖到此处，或</el-link><el-link :underline="false" type="primary">点击上传</el-link></div> -->
    </el-upload>
  </div>
</template>

<script>
// import SparkMD5 from 'spark-md5'
// import Qs from 'qs'
// AdminCheckMd5, AdminUploadBigFile
// import { AdminDownLoadFile, uploadFileDownload, Uploadimg, Uploadimgs } from '@/api/system'
import { Uploadimg, Uploadimgs } from '@/api/system'
// AdminDownLoadFile
export default {
  props: ['limit', 'callbackShow', 'accept', 'type', 'checked', 'size'],
  data () {
    return {
      num: '',
      info: {},
      fileList: [],
      fileArr: []
    }
  },
  watch: {
    callbackShow(newValue, oldValue) {
      if (newValue) {
        newValue.forEach(element => {
          element.name = element.remark
        })
        this.fileList = newValue
        this.fileArr = newValue
      }
    },
    fileArr (newValue, oldValue) {
      const arr = []
      for (let i = 0; i < newValue.length; i++) {
        arr.push(newValue[i].path)
      }
      this.$emit('UploadFileFun', arr.join(','))
    }
  },
  created () {
    if (this.callbackShow && this.callbackShow.length > 0) {
      this.callbackShow.forEach(element => {
        element.name = element.remark
      })
      this.fileList = this.callbackShow
      this.fileArr = this.callbackShow
    }
  },
  methods: {
    // 超出文件个数限制提示
    handleExceed() {
      this.$message.warning(`最多上传 ${this.limit} 个文件。`)
    },
    // 下载
    handlePreview (file) {
      // const params = { path: file.path }
      // AdminDownLoadFile(params).then(res => {
      //   const blob = new Blob([res.data])
      //   const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
      //   if ('download' in document.createElement('a')) { // 非IE下载
      //     const elink = document.createElement('a')
      //     elink.download = fileName
      //     elink.style.display = 'none'
      //     elink.href = URL.createObjectURL(blob)
      //     document.body.appendChild(elink)
      //     elink.click()
      //     URL.revokeObjectURL(elink.href) // 释放URL 对象
      //     document.body.removeChild(elink)
      //   } else { // IE10+下载
      //     navigator.msSaveBlob(blob, fileName)
      //   }
      // })
      // }
    },
    // 上传成功
    handleChange (file, fileList) {
      this.fileList = fileList
    },
    // 删除文件
    handleRemove(file, fileList) {
      // console.log(file, fileList)
      for (let i = 0; i < this.fileArr.length; i++) {
        if (file.path == this.fileArr[i].path) {
          this.fileArr.splice(i, 1)
        }
      }
      this.fileList = fileList
    },
    // 检测文件大小
    beforeAvatarUpload(rawFile) {
      // console.log(process.env.VUE_APP_IMG_URL)
      const sizes = this.size || 100
      const isLt2M = rawFile.size / 1024 / 1024 < sizes
      if (!isLt2M) {
        this.$message.warning(`上传文件大小不能超过 ${sizes}MB!`)
        return false
      }
      // return isLt2M
      const testmsg = rawFile.name.substring(rawFile.name.lastIndexOf('.'))
      if (this.accept) {
        const list = this.accept.split(',')
        if (!list.includes(testmsg)) {
          this.$message.warning(`请上传${this.accept}类型的文件`)
          return false
        }
      }
    },
    AdminUploadFileUp (f) {
      // const file = f.file
      // var that = this
      // var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      // var fileMd5
      // if (file.size > 1024 * 1024 * 6) {
      //   f.onProgress({ percent: 0 })
      //   // calculteFileMd5()
      // } else {
      const formdata = new FormData()
      formdata.append('file', f.file)
      const ff = {
        onUploadProgress: progressEvent => {
          const num = (progressEvent.loaded / progressEvent.total * 100)
          this.num = num
          f.onProgress({ percent: num })
        },
        timeout: 0
      }
      if (this.type) {
        Uploadimgs(formdata, ff).then(res => {
          if (res.code === '000') {
            // this.$message.success('上传成功')
            this.fileList[this.fileList.length - 1].path = res.result.filesMap.file[0].path
            this.fileArr.push(res.result.filesMap.file[0])
            if (this.num == 100) {
              f.onSuccess()
            }
          } else {
            // this.$msg(res.msg, { type: 'error' })
            // this.$message.error(res.msg)
            this.fileList.splice(this.fileList.length - 1, 1)
            this.hideUploadEdit = this.fileList.length >= this.limit
          }
        }).catch(() => {
          this.fileList.splice(this.fileList.length - 1, 1)
          this.hideUploadEdit = this.fileList.length >= this.limit
        })
      } else {
        Uploadimg(formdata, ff).then(res => {
          if (res.code === '000') {
            // this.$message.success('上传成功')
            this.fileList[this.fileList.length - 1].path = res.result.filesMap.file[0].path
            this.fileArr.push(res.result.filesMap.file[0])
            if (this.num == 100) {
              f.onSuccess()
            }
          } else {
            // this.$msg(res.msg, { type: 'error' })
            // this.$message.error(res.msg)
            this.fileList.splice(this.fileList.length - 1, 1)
            this.hideUploadEdit = this.fileList.length >= this.limit
          }
        }).catch(() => {
          this.fileList.splice(this.fileList.length - 1, 1)
          this.hideUploadEdit = this.fileList.length >= this.limit
          // this.$msg('上传失败', { type: 'error' })
        })
      }
      //
      // }
      // function calculteFileMd5 () {
      //   const chunkSize = 1024 * 1024 * 3 // Read in chunks of 2MB 。每一块的大小
      //   const chunks = Math.ceil(file.size / chunkSize) // 整个文件可分为多少块，向下取整
      //   var currentChunk = 0 // 当前加载的块。初始化为0
      //   const spark = new SparkMD5.ArrayBuffer()
      //   const fileReader = new FileReader()

      //   fileReader.onload = e => {
      //     spark.append(e.target.result)
      //     currentChunk++
      //     if (currentChunk < chunks) {
      //       loadNext()
      //     } else {
      //       // 计算出文件的md5值
      //       fileMd5 = spark.end()
      //       // 服务器检查文件是否存在
      //       requestCheckFile()
      //     }
      //   }
      //   loadNext()
      //   function loadNext () {
      //     var start = currentChunk * chunkSize
      //     var end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
      //     fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      //   }
      // }
      // // 请求服务器验证文件
      // function requestCheckFile () {
      //   console.log(f.file.name)
      //   AdminCheckMd5(Qs.stringify({ md5: fileMd5, name: f.file.name, totalBytes: f.file.size })).then(res => {
      //     // console.log(res)
      //     if (res.code !== '000') {
      //       that.$message.error(res.msg)
      //       that.fileList.splice(that.fileList.length - 1, 1)
      //       that.hideUploadEdit = that.fileList.length >= that.limit
      //     } else {
      //       if (!res.result.complete) {
      //         requestRealUpload(res.result)
      //       } else {
      //         that.fileList[that.fileList.length - 1].path = res.result.uploadVo.filesMap.file[0].path
      //         that.fileArr.push(res.result.uploadVo.filesMap.file[0])
      //         f.onProgress({ percent: 100 })
      //         setTimeout(() => {
      //           that.$message.success('上传成功')
      //           f.onSuccess()
      //         })
      //       }
      //     }
      //   }).catch(() => {
      //     that.fileList.splice(that.fileList.length - 1, 1)
      //     that.hideUploadEdit = that.fileList.length >= that.limit
      //   })
      // }
      // // 分块上传
      // function requestRealUpload (params) {
      //   var chunkSize = 1024 * 1024 * 3
      //   uploadChunk(params.uploadedBytes)
      //   // 请求服务端，上传一块
      //   function uploadChunk (uploadedBytes) {
      //     var formData = new FormData()
      //     var start = uploadedBytes
      //     var end = Math.min(Number(start) + chunkSize, f.file.size)
      //     formData.append('upfile', blobSlice.call(file, start, end))
      //     formData.append('md5', fileMd5)
      //     const ff = {
      //       onUploadProgress: progressEvent => {
      //         // console.log(progressEvent)
      //         // const num = (progressEvent.loaded / progressEvent.total * 100)
      //         const num = (end / f.file.size * 100)
      //         that.num = num
      //         f.onProgress({ percent: num })
      //       },
      //       timeout: 0
      //     }
      //     AdminUploadBigFile(formData, ff).then(res => {
      //       if (res.code !== '000') {
      //         that.$message.error(res.msg)
      //         that.fileList.splice(that.fileList.length - 1, 1)
      //         that.hideUploadEdit = that.fileList.length >= that.limit
      //       } else {
      //         if (res.result < f.file.size) {
      //           uploadChunk(res.result)
      //         } else {
      //           that.fileList[that.fileList.length - 1].path = res.result.filesMap.file[0].path
      //           that.fileArr.push(res.result.filesMap.file[0])
      //           if (that.num == 100) {
      //             that.$message.success('上传成功')
      //             f.onSuccess()
      //           }
      //         }
      //       }
      //     }).catch(() => {
      //       that.fileList.splice(that.fileList.length - 1, 1)
      //       that.hideUploadEdit = that.fileList.length >= that.limit
      //     })
      //   }
      // }
    }
  }
}
</script>

<style>
</style>

<style lang="less" scoped>
.upload-demo {
  max-width: 400px;
}
</style>
